<template>
    <div class="col-md-6 p-0 mr-5">
        <div class="text-center calculator__main">
            <p>Please Choose Between Two</p>
            <button @click="emitToParent('CalcStep1', 'export')" class="export" type="button" name="button">Export</button>
            <button @click="emitToParent('CalcStep1', 'import')" class="import" type="button" name="button">Import</button>
        </div>
    </div>
</template>

<script>
export default {
  name: 'StartCalculator',
  data: () => ({
    form: {
      stepName: '',
      shipment: ''
    }
  }),
  methods: {
    emitToParent (stepName, shipment) {
      this.form.stepName = stepName
      this.form.shipment = shipment
      this.$emit('activeForm', this.form)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/storagecalculator/StartCalculator.vue